import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

export default function Vision() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section className="vision-section" aria-label="Our vision">
      <div ref={ref} className={`vision-inner fade-up ${visible ? 'visible' : ''}`}>
        <span className="vision-label">Our Vision</span>
        <blockquote className="vision-quote">
          We believe every signed document<br />
          should come with <em>proof.</em>
        </blockquote>
        <p className="vision-body">
          Pramaan is building the infrastructure layer for digital execution
          in India — combining signing, identity verification, evidence, and
          compliance into a single platform that businesses can trust.
        </p>
      </div>
    </section>
  );
}
